import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AdminOrder } from '../../types/types';
import dataService from '../../data/dataService';
import '../../styles/Admin.css';

const ORDER_STATUSES = ['', 'Pending', 'Processing', 'Shipped', 'Delivered', 'Cancelled'];

const OrderManagement: React.FC = () => {
  const [orders, setOrders] = useState<AdminOrder[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  const loadOrders = (status?: string) => {
    setLoading(true);
    dataService.getAdminOrders(status || undefined).then(setOrders).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { loadOrders(); }, []);

  const handleStatusChange = async (orderId: number, newStatus: string) => {
    await dataService.updateOrderStatus(orderId, newStatus);
    loadOrders(filter || undefined);
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Order Management</h1>
        <nav className="admin-nav">
          <Link to="/admin">Dashboard</Link>
          <Link to="/admin/products">Products</Link>
          <Link to="/admin/reviews">Reviews</Link>
          <Link to="/admin/discounts">Discounts</Link>
          <Link to="/admin/agent-dashboard">Agent Demo</Link>
        </nav>
      </div>

      <div className="admin-filter">
        <label>Filter:</label>
        <select value={filter} onChange={e => { setFilter(e.target.value); loadOrders(e.target.value); }}>
          {ORDER_STATUSES.map(s => <option key={s} value={s}>{s || 'All'}</option>)}
        </select>
      </div>

      {loading ? <p>Loading...</p> : orders.length === 0 ? <p>No orders found.</p> : (
        <table className="admin-table">
          <thead>
            <tr><th>ID</th><th>Customer</th><th>Email</th><th>Items</th><th>Total</th><th>Status</th><th>Date</th></tr>
          </thead>
          <tbody>
            {orders.map(o => (
              <tr key={o.id}>
                <td>#{o.id}</td>
                <td>{o.userName}</td>
                <td>{o.userEmail}</td>
                <td>{o.itemCount}</td>
                <td>${o.total.toFixed(2)}</td>
                <td>
                  <select value={o.status} onChange={e => handleStatusChange(o.id, e.target.value)}>
                    {ORDER_STATUSES.filter(s => s).map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td>{new Date(o.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OrderManagement;
